import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const I_KEYBOARDING_ACTIVITY_VIDEO_FRAGMENT = gql `
  fragment KeyboardingActivityVideoFragment on KeyboardingActivityVideo {
    id
    name
    description
    videoId
    autoPlay
    video {
      ...AssetFragment
    }
    device
  }
  ${ASSET_FRAGMENT}
`;
export default I_KEYBOARDING_ACTIVITY_VIDEO_FRAGMENT;
